module.exports = __webpack_public_path__ + "static/media/Service Information – Arabic.26223ac6.jpg";